import { Stack, Box, Alert, Text, TextLink } from 'braid-design-system';
import React, { Fragment } from 'react';

interface ErrorSectionProps {
  texts: string[];
  contactUsLink?: string;
}

export default ({ texts, contactUsLink }: ErrorSectionProps) => (
  <Fragment>
    <Alert tone="critical">
      <Stack space="medium">
        {texts.map((text, index) => (
          <Box key={index} component="p">
            <Text>{text}</Text>
          </Box>
        ))}
        {contactUsLink ? (
          <Text>
            <TextLink href={contactUsLink} target="_blank">
              Get in touch with our local team.
            </TextLink>
          </Text>
        ) : null}
      </Stack>
    </Alert>
  </Fragment>
);

export type { ErrorSectionProps };
